import React from 'react'
import PropTypes from 'prop-types'
import { IconSLI60Wrapper } from './IconSLI60Wrapper'

export const Icon60PaperPlane = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLI60Wrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 47.906 47.906'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M47.805,0.628 C47.846,0.726 47.873,0.828 47.881,0.934 C47.881,0.943 47.885,0.952 47.885,0.961 C47.890,1.057 47.881,1.156 47.856,1.253 L36.882,44.157 C36.803,44.463 36.584,44.714 36.291,44.834 C36.170,44.882 36.043,44.907 35.916,44.907 C35.734,44.907 35.554,44.857 35.395,44.760 L24.841,38.310 C24.818,38.365 24.808,38.424 24.774,38.476 L18.788,47.456 C18.599,47.738 18.285,47.900 17.958,47.900 C17.861,47.900 17.765,47.886 17.669,47.857 C17.248,47.729 17.000,47.345 17.000,46.905 L17.000,33.194 C16.993,33.169 16.999,33.142 16.994,33.116 C16.979,33.036 16.972,32.958 16.977,32.876 C16.979,32.822 16.988,32.772 16.999,32.719 C17.016,32.645 17.040,32.576 17.074,32.507 C17.088,32.476 17.088,32.443 17.106,32.414 C17.123,32.386 17.147,32.367 17.170,32.345 C17.189,32.319 17.196,32.288 17.218,32.264 L42.580,4.275 L3.161,23.988 L13.713,29.686 C14.198,29.948 14.379,30.553 14.117,31.038 C13.856,31.522 13.250,31.704 12.765,31.442 L0.524,24.831 C0.196,24.655 -0.006,24.310 0.000,23.938 C0.006,23.566 0.219,23.228 0.551,23.062 L46.443,0.113 C46.448,0.110 46.454,0.110 46.459,0.108 C46.479,0.098 46.500,0.095 46.521,0.087 C46.609,0.052 46.699,0.029 46.792,0.020 C46.828,0.017 46.863,0.016 46.900,0.017 C46.986,0.018 47.070,0.030 47.154,0.053 C47.183,0.061 47.212,0.065 47.240,0.075 C47.338,0.112 47.432,0.161 47.516,0.229 C47.525,0.236 47.531,0.246 47.539,0.254 C47.545,0.259 47.553,0.260 47.560,0.266 C47.575,0.280 47.581,0.299 47.595,0.314 C47.661,0.382 47.717,0.456 47.761,0.539 C47.777,0.569 47.793,0.597 47.805,0.628 ZM35.284,42.353 L44.925,4.660 L19.507,32.711 L35.284,42.353 ZM18.955,43.607 L23.114,37.369 C23.133,37.340 23.163,37.325 23.185,37.298 L18.955,34.713 L18.955,43.607 Z'
        />
      </svg>
    </IconSLI60Wrapper>
  )
}

Icon60PaperPlane.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
